<template>
    <div id="app" @click="onMousemove" v-loading="loading"
    element-loading-text="版本更新,重置页面中..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.3)">
        <router-view/>
    </div>
</template>

<script>
import Vue from "vue";
import VueCookie from "vue-cookie";
import {getEmployee} from "@/api/order.js";
import axios from "axios";

import { mapActions } from "vuex";
export default {
    name: 'App',
    data() {
        return {
            loading:false
        };
    },
    created() {
        // 页面可见时才轮询检测版本（如每 60 秒），隐藏时暂停
        this.startVersionPolling()
        document.addEventListener('visibilitychange', this.onVisibilityChange)
    },
    beforeDestroy() {
        document.removeEventListener('visibilitychange', this.onVisibilityChange)
        this.stopVersionPolling()
    },
    watch: {
        '$route'(e) {
            if (e.query.token && e.query.token != 'undefined') {
                this.GetToken(this.$route.query.token)
                this.getEmployee(this.$route.query.token)
            }
            if (e.query.session) {
                this.GetSession(this.$route.query.session)
            }
        }
    },
    methods: {
        ...mapActions(["GetToken","GetSession",'GetEmployee']),
        // 页面可见性变化：回到前台立即检测一次，并根据可见状态启停轮询
        onVisibilityChange(){
            if (document.visibilityState === 'visible') {
                this.checkVersion()
                this.startVersionPolling()
            } else {
                this.stopVersionPolling()
            }
        },
        // 启动定时轮询（避免重复创建）
        startVersionPolling(){
            if (this.versionTimer) return
            this.versionTimer = setInterval(() => {
                this.checkVersion()
            }, 60000)
        },
        // 停止定时轮询
        stopVersionPolling(){
            clearInterval(this.versionTimer)
            this.versionTimer = null
        },
        // 点击触发检测（带防抖，5 秒内只检测一次）
        onMousemove(){
            const now = Date.now()
            if (this._lastCheck && now - this._lastCheck < 5000) return
            this._lastCheck = now
            this.checkVersion()
        },
        // 版本检测：请求带时间戳穿透缓存，与本地版本对比，不同则强制刷新
        async checkVersion(){
            try {
                let res = await axios.get(`${window.location.origin}/static/version.json?t=${Date.now()}`)
                let version = res.data.lastBuildTimeStamp + ''
                let clientVersion = window.localStorage.getItem('crm_version')
                console.log('版本检测', version, clientVersion)
                // 和最新版本不同，刷新页面
                if (version !== clientVersion) {
                    window.localStorage.setItem('crm_version', version)
                    this.loading = true
                    setTimeout(()=>{
                        this.loading = false
                        window.location.reload();
                    },1500)
                }
            } catch (e) {
                console.error('版本检测失败', e)
            }
        },
        getEmployee(token){
            getEmployee({token:token}).then((res)=>{
                this.GetEmployee(res.result)
            })
        }
    }
}
</script>

<style scoped>
</style>
  


// WEBPACK FOOTER //
// src/App.vue